import '../common/i18n'
import Layout from '../common/Layout'
import Body from './body'
import DisplayType from './header/DisplayType'
import LeftBar from './header/LeftBar'

const PortfolioFinance = () => {
  return (
    <Layout
      hasCurrencyUnit={true}
      renderCustomHeader={() => <DisplayType />}
      renderLeftBar={() => <LeftBar />}
      renderBottom={() => <Body />}
    />
  )
}

export default PortfolioFinance
